import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {Existing, IdentifiableModel} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import {ModificationDetails} from "../ModificationDetails";
import {RateOnlyExchangeRate} from "./ExchangeRate";

export type CurrencyIsoCode = string;

export class IdOnlyCurrency implements IdentifiableModel<CurrencyIsoCode> {
  @autoserializeAs(() => String)
  public isoCode: CurrencyIsoCode;

  public get id(): CurrencyIsoCode {
    return this.isoCode;
  }

  public set id(id: CurrencyIsoCode) {
    this.isoCode = id;
  }

  public static existing(isoCode: CurrencyIsoCode): Existing<IdOnlyCurrency> {
    return new IdOnlyCurrency(isoCode);
  }

  public constructor(isoCode: CurrencyIsoCode) {
    this.isoCode = isoCode;
  }
}

@inheritSerialization(() => IdOnlyCurrency)
export class SimpleCurrency extends IdOnlyCurrency {
  @autoserializeAs(() => RateOnlyExchangeRate)
  public readonly currentEuroExchangeRate?: Readonly<Existing<RateOnlyExchangeRate>>;
}

/**
 * @sealed
 */
@inheritSerialization(() => SimpleCurrency)
export class Currency extends SimpleCurrency implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}
